import VerticalStepsList from "./VerticalStepsList";

export default VerticalStepsList;
